import { slick } from 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
export default {
  init() {
    if($('.impact-carousel').length){
      $('.impact-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        infinite: true,
        autoplay : false,
        arrows: true,
        dots: false,
        centerMode: true,
        centerPadding : '250px'
      });
    }


    if($('.carousel-sections').length){
      $('.carousel-sections').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        infinite: true,
        autoplay : false,
        arrows: false,
        dots: false,
      });
      $('.carousel-titles > h2').on('click', function(){
        $('.carousel-titles > h2').removeClass('active');
        $(this).addClass('active');
        $('.carousel-sections').slick('slickGoTo', $(this).index());
      });
    }

    if($('.testimonials-new-slider').length){
      $('.testimonials-new-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows:true,        
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true
            }
          }
        ]
      });
    }

    if($('.why-statements').length){
      $('.why-statements').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows:true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true
            }
          }
        ]
      });
    }

    if($('.awards-statements').length){

      $('.awards-statements').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows:true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true
            }
          }
        ]
      });
    }

    if($('.companies-logos-slider').length){

      $('.companies-logos-slider').slick({
        slidesToShow:1,
        speed: 6000,
        slidesToScroll: 1,
        autoplay: true,
        cssEase: 'linear',
        autoplaySpeed: 1,
        arrows : false,
        infinite: true,
        variableWidth: true
      })
    }

    // $('.companies-logos').slick({
    //   slidesToShow: 6,
    //   slidesToScroll: 1,
    //   autoplay: true,
    //   autoplaySpeed: 2000,
    //   arrows:false,
    //   pauseOnHover : true,
    //   adaptiveHeight: true,
    //   centerPadding : '200px',
    //   responsive: [
    //     {
    //       breakpoint: 1024,
    //       settings: {
    //         slidesToShow: 3,
    //         slidesToScroll: 1,
    //         infinite: true
    //       }
    //     },
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 2,
    //         slidesToScroll: 1,
    //         infinite: true
    //       }
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         infinite: true
    //       }
    //     }
    //   ]
    // });

    //$('[data-position=2],[data-position=3],[data-position=4],[data-position=5],[data-position=6],[data-position=7]').hide();
    
    /* function companyRotate(){
      var companyNumber = 1;
      var company = '.company';
      $('.company-1').slideUp(100);
      $('.company-2').delay(2000).slideUp(100);
      $('.company-3').delay(3500).slideUp(100);
      $('.company-4').delay(5000).slideUp(100);
      $('.company-5').delay(6500).slideUp(100);
      $('.company-6').delay(8000).slideUp(100);
      $('.company').each(function(){
        var position = $(this).attr('data-position');
        var newPosition = position - 1;
        if(newPosition == 0){
          newPosition = 7;
        }

        $(this).attr('data-position', newPosition);
      });

      $('.company-1[data-position=1]').delay(300).fadeIn();
      $('.company-2[data-position=1]').delay(400).fadeIn();
      $('.company-3[data-position=1]').delay(500).fadeIn();
      $('.company-4[data-position=1]').delay(600).fadeIn();
      $('.company-5[data-position=1]').delay(700).fadeIn();
      $('.company-6[data-position=1]').delay(800).fadeIn();
    }

    setInterval(companyRotate, 3000); */
    if($(window).width() <= 768){
      $('.block-full-main ul').slick();

      if($('.solution-wrap').length){

        $('.solution-wrap').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false, 
          centerMode : true
        });
      }
    }

  },
  finalize() {}
}